export const filterCondition: Record<string, string> = {
  contains: 'CONTAINS',
  notContains: 'DOES_NOT_CONTAIN',
  equals: 'EQUALS',
  notEqual: 'DOES_NOT_EQUAL',
  startsWith: 'BEGIN_WITH',
  endsWith: 'ENDS_WITH',
  greaterThan: 'GREATER_THAN',
  greaterThanOrEqual: 'GREATER_THAN_OR_EQUAL_TO',
  lessThan: 'LESS_THAN',
  lessThanOrEqual: 'LESS_THAN_OR_EQUAL_TO',
};

export const filterDateCondition: Record<string, string> = {
  equals: 'EQUALS',
  notEqual: 'DOES_NOT_EQUAL',
  lessThan: 'BEFORE',
  greaterThan: 'AFTER',
  inRange: 'BETWEEN',
};
